import { centsToDollar } from '@givebacks/utils/currency';
import { getRecentDonationTime } from '@givebacks/utils/date';
import { Avatar, Box, Divider } from '@mantine/core';

import { Group, Stack } from '../../../../Layout';
import { Text } from '../../../../Typography';

type RecentDonationProps = {
  donorName: string;
  status?: 'pledged' | 'purchased';
  total?: number;
  date: string;
  pledged?: {
    units: string;
    amount: number;
  };
  creditedTo?: string;
};

const RecentDonationInfo = ({
  donorName,
  status,
  total,
  pledged,
  creditedTo,
}: Partial<RecentDonationProps>) => {
  return (
    <Text fz="xs" fw={500}>
      {donorName}
      <Box component="span" c="gray" fw={400}>
        {' '}
        {status === 'purchased' ? 'donated' : status}{' '}
      </Box>
      {centsToDollar(status === 'pledged' ? pledged?.amount : total)}
      {creditedTo && (
        <>
          <Box component="span" c="gray" fw={400}>
            {status === 'pledged' ? ` / ${pledged?.units} to ` : ' to '}
          </Box>
          {creditedTo}
        </>
      )}
    </Text>
  );
};

const RecentDonation = ({
  donorName,
  status = 'purchased',
  total,
  date,
  pledged,
  creditedTo,
}: RecentDonationProps) => {
  return (
    <Group gap="sm" align="flex-start" w="100%">
      <Avatar
        color="cobalt"
        styles={(theme) => ({ placeholder: { fontWeight: 500, color: theme.colors.cobalt[5] } })}
        name={donorName}
      />
      <Stack gap="xs" flex={1}>
        <Box w="100%">
          <RecentDonationInfo
            donorName={donorName}
            status={status}
            total={total}
            pledged={pledged}
            creditedTo={creditedTo}
          />

          {date && (
            <Text fz="xxxs" c="gray">
              {getRecentDonationTime(date)}
            </Text>
          )}
        </Box>
        {/* TODO: future designs to implement donor messages with new component  */}
        <Divider mt={8} />
      </Stack>
    </Group>
  );
};

export { RecentDonation };
